import Tabs from 'antd/lib/tabs'
import './index.less'

export default Tabs



// WEBPACK FOOTER //
// ./src/elements/tabs/index.js